/**
 * @voltxampere/ui — BC557 PNP BJT variant (Sprint 38-1)
 *
 * Reference: TI BC557 spec (TO-92 PNP complement to BC547).
 *   Is = 1.0e-14 A
 *   Bf = 200            (B group; A=125, B=240, C=475 sub-bins)
 *   Vaf = 50 V
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { pnp } from "../pnp.js";
export const bjtPnpBc557 = {
    id: "bc557",
    nameTr: "BC557 (PNP, TO92)",
    nameEn: "BC557 (PNP, TO92)",
    shortcut: "Q",
    category: "active",
    viewBox: pnp.viewBox,
    terminals: pnp.terminals,
    defaultLabel: "Q",
    defaultValue: "BC557",
    schemaType: "bjt-pnp",
    defaultParams: { Is: 1.0e-14, Bf: 200, Vaf: 50 },
    renderSVG: () => pnp.renderSVG(),
};
//# sourceMappingURL=bjt-pnp-bc557.js.map